import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemService } from './system.service';

export interface Module {
  id: number;
  name: string;
  url: string | null;
  icon: string | null;
  parent: number;
  order: number;
  children?: Module[];
  enabled: boolean;
  translations: { [key: string]: string }; // Add this for multi-language names (e.g., en, fr, de)
}

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private http: HttpClient, private system: SystemService) {}

  getModules(): Observable<Module[]> {
    return this.http.get<Module[]>(`${this.system.apiURL}/modules`);
  }

  getAppModules(): Observable<Module[]> {
    return this.http.get<Module[]>(`${this.system.apiURL}/app-modules`);
  }

  updateModuleHierarchy(updatedHierarchy: Module[], type: string): Observable<any> {
    // Make the HTTP POST request to the backend API
    return this.http.post(`${this.system.apiURL}/modules/update-hierarchy`, {hierarchy: updatedHierarchy, type: type});
  }

  updateTranslations(translations, enabled: boolean = false, moduleId: number, type: string): Observable<any> {
    // Make the HTTP POST request to the backend API
    return this.http.put(`${this.system.apiURL}/modules/${moduleId}/update-translations`, {translations: translations, enabled: enabled, type: type});
  }

  getMenus(): Observable<any[]> {
    return this.http.get<any[]>(`${this.system.apiURL}/modules/menus`);
  }

  createModule(module: Module): Observable<Module> {
    return this.http.post<Module>(`${this.system.apiURL}/modules`, module);
  }  
}
